// 這是獨立的內容設定檔，方便日後擴充與維護

// 1. 各種類別的設定與對應的引導文字
export const categories = [
  { id: 'emotion', label: '感情', emptyPrompt: '寫下關於他/她，那些無法寄出的話...', typingPrompt: '讓情緒流淌，我在這裡陪你...' },
  { id: 'work', label: '工作', emptyPrompt: '寫下那些壓力、疲憊與不被理解...', typingPrompt: '深呼吸，把重擔卸下在這裡...' },
  { id: 'self', label: '自我', emptyPrompt: '寫下對自己的苛責，或是心裡的迷惘...', typingPrompt: '慢慢寫，不用急著堅強...' },
  { id: 'other', label: '其他', emptyPrompt: '把心事寫下來。不用急，慢慢來。', typingPrompt: '每一個字，都是一種釋放...' }
];

// 2. 儀式完成後的分類隨機結尾語錄
export const endingMessages = {
  emotion: [
    { title: "輕舟已過。", subtitle: "那些心裡的萬重山，\n\n都已經留在身後了。" },
    { title: "漂遠了。", subtitle: "那些未曾說出口的話，\n\n已經被溫柔接住。" },
    { title: "放下了。", subtitle: "留在原地的，\n\n只剩平靜的回憶。" },
    { title: "釋懷了。", subtitle: "不再執著，\n\n就是對自己最好的溫柔。" },
    { title: "結束了。", subtitle: "一段旅程的終點，\n\n是另一段新生的起點。" },
    { title: "走遠了。", subtitle: "把心騰出空間，\n\n才能裝進新的陽光。" },
    { title: "沉睡了。", subtitle: "那些心碎的聲音，\n\n已被湖水撫平。" },
    { title: "融化了。", subtitle: "所有的不甘心，\n\n都化作了夜裡的星光。" },
    { title: "自由了。", subtitle: "你的心，\n\n又重新屬於你自己。" },
    { title: "告別了。", subtitle: "揮揮手，\n\n向那個曾經用力的自己說聲謝謝。" },
    { title: "鬆開了。", subtitle: "不再緊抓著，\n\n原來可以這麼輕盈。" },
    { title: "遠去了。", subtitle: "那些遺憾，\n\n都會成為未來的養分。" },
    { title: "平靜了。", subtitle: "沒有回音的山谷，\n\n就讓它安靜吧。" },
    { title: "化解了。", subtitle: "原諒別人，\n\n最終是放過了自己。" },
    { title: "隨風了。", subtitle: "讓風帶走，\n\n那些無以名狀的痛。" },
    { title: "交給湖水了。", subtitle: "你的眼淚，\n\n今晚有人替你收藏。" },
    { title: "看淡了。", subtitle: "曾經的波瀾壯闊，\n\n如今只是一抹微波。" },
    { title: "不遺憾了。", subtitle: "相愛過，\n\n本身就是一種圓滿。" }
  ],
  work: [
    { title: "化作輕舟。", subtitle: "今天的沉重與疲憊，\n\n不再壓在你心上。" },
    { title: "下班了。", subtitle: "把重量卸下，\n\n今晚的你只屬於你自己。" },
    { title: "卸下了。", subtitle: "那些壓力與責任，\n\n暫時留在湖底吧。" },
    { title: "休息吧。", subtitle: "機器都需要暫停，\n\n更何況是活生生的你。" },
    { title: "夠好了。", subtitle: "你今天已經做得很好了，\n\n真的。" },
    { title: "暫停了。", subtitle: "世界不會因為你休息一天，\n\n就停止轉動。" },
    { title: "抽離了。", subtitle: "工作只是生活的一部分，\n\n不是全部。" },
    { title: "空白了。", subtitle: "允許自己有一段時間，\n\n什麼都不做。" },
    { title: "關機了。", subtitle: "切斷那些紛擾，\n\n聽聽自己呼吸的聲音。" },
    { title: "遠離了。", subtitle: "那些不被理解的委屈，\n\n隨著小船漂遠了。" },
    { title: "深呼吸。", subtitle: "吸進平靜，\n\n吐出所有的焦慮與疲憊。" },
    { title: "沉澱了。", subtitle: "混濁的思緒，\n\n需要時間慢慢清澈。" },
    { title: "辛苦了。", subtitle: "拍拍自己的肩膀說：\n\n「今天撐過來了。」" },
    { title: "放晴了。", subtitle: "烏雲會散去，\n\n明天又是新的一天。" },
    { title: "脫下盔甲了。", subtitle: "在這裡，\n\n你不需要假裝堅強。" },
    { title: "下車了。", subtitle: "離開這班擁擠的列車，\n\n沿途風景其實很美。" },
    { title: "慢慢走。", subtitle: "跑得太快的時候，\n\n記得停下來等一等靈魂。" },
    { title: "放假了。", subtitle: "給心靈放個假，\n\n這份假單已經被宇宙批准。" }
  ],
  self: [
    { title: "輕盈了。", subtitle: "沒有什麼是放不下的，\n\n包括那個執著的自己。" },
    { title: "和解了。", subtitle: "不再苛責自己，\n\n是最大的溫柔。" },
    { title: "擁抱了。", subtitle: "抱抱那個，\n\n總覺得自己不夠好的內在小孩。" },
    { title: "接納了。", subtitle: "承認自己的脆弱，\n\n其實也是一種勇敢。" },
    { title: "允許了。", subtitle: "允許自己偶爾迷惘，\n\n允許自己原地踏步。" },
    { title: "不完美也很好。", subtitle: "裂縫，\n\n那是光照進來的地方。" },
    { title: "疼惜了。", subtitle: "你已經很棒了，\n\n請對自己好一點。" },
    { title: "停下來了。", subtitle: "不用一直往前衝，\n\n停下來看看風景吧。" },
    { title: "原諒自己了。", subtitle: "過去的錯誤，\n\n只是為了讓你學會成長。" },
    { title: "鬆綁了。", subtitle: "解開那些，\n\n自己給自己的枷鎖。" },
    { title: "慢慢來。", subtitle: "你的花期，\n\n跟別人不一樣也沒關係。" },
    { title: "找回了。", subtitle: "撥開迷霧，\n\n看見最真實的自己。" },
    { title: "安撫了。", subtitle: "心裡的那場風暴，\n\n漸漸平息了。" },
    { title: "不逼迫了。", subtitle: "順其自然，\n\n也是一種生活方式。" },
    { title: "呼吸了。", subtitle: "感受空氣進出，\n\n你正真實地活著。" },
    { title: "被接住了。", subtitle: "當你不再堅強，\n\n這裡有一片柔軟的湖水托著你。" },
    { title: "原諒軟弱。", subtitle: "軟弱從來不是罪，\n\n那是你需要休息的訊號。" },
    { title: "重新開始。", subtitle: "每一天的晨光，\n\n都是為你準備的重生。" }
  ],
  other: [
    { title: "隨波了。", subtitle: "跟著水流，\n\n把重量交還給天地。" },
    { title: "散了。", subtitle: "那些無以名狀的憂愁，\n\n都已隨風而逝。" },
    { title: "消失了。", subtitle: "沉入湖底，\n\n化為無形。" },
    { title: "沉了。", subtitle: "所有的沉重，\n\n都被溫柔地接住了。" },
    { title: "飄了。", subtitle: "像一片落葉，\n\n輕輕落在水面上。" },
    { title: "宇宙接住了。", subtitle: "你所有的墜落，\n\n都有浩瀚為你托底。" },
    { title: "化為星斑。", subtitle: "那些心事，\n\n變成了夜空中的點綴。" },
    { title: "交付黑夜。", subtitle: "黑夜會包容一切，\n\n包括你的不安。" },
    { title: "晚安了。", subtitle: "今晚，\n\n請給自己一個好夢。" },
    { title: "平息了。", subtitle: "水面恢復平靜，\n\n心也是。" },
    { title: "隱沒了。", subtitle: "消失在迷霧中，\n\n不再困擾你。" },
    { title: "無痕了。", subtitle: "像船過水無痕，\n\n一切終將過去。" },
    { title: "隨風而逝。", subtitle: "抓不住的，\n\n就讓它走吧。" },
    { title: "輕拂了。", subtitle: "像微風拂過臉龐，\n\n不留一絲痕跡。" },
    { title: "已成過往。", subtitle: "翻過這一頁，\n\n迎接新的篇章。" },
    { title: "萬物靜好。", subtitle: "在這一刻，\n\n世界對你只有全然的溫柔。" },
    { title: "化為塵埃。", subtitle: "那些沉重的事，\n\n在宇宙尺度下輕如鴻毛。" },
    { title: "浮木。", subtitle: "當你累了，\n\n總會有浮木在大海中接住你。" }
  ]
};